<div class="sf-br-dt" [class.is-disabled]="disabled">
  <div class="sf-br-dt__date">
    <input
      type="text"
      class="form-control"
      [id]="inputId || null"
      [matDatepicker]="picker"
      [value]="calendarValue"
      [min]="minCalendar"
      [max]="maxCalendar"
      (dateChange)="onCalendarChange($event.value)"
      (click)="picker.open()"
      [disabled]="disabled"
      placeholder="dd/mm/aaaa"
      maxlength="10"
      inputmode="numeric"
      autocomplete="off"
      [attr.data-testid]="testId ? testId + '-date' : null"
    />
    <mat-datepicker-toggle class="sf-br-dt__toggle" [for]="picker" [disabled]="disabled"></mat-datepicker-toggle>
    <mat-datepicker #picker panelClass="sf-br-dt-panel"></mat-datepicker>
  </div>

  <div class="sf-br-dt__time" *ngIf="showTime">
    <select
      class="form-select"
      aria-label="Hora"
      [ngModel]="hour"
      (ngModelChange)="onHourChange($event)"
      [disabled]="disabled || !datePart"
      [attr.data-testid]="testId ? testId + '-hour' : null"
    >
      <option value="" disabled>hh</option>
      <option *ngFor="let option of hourOptions; trackBy: trackByValue" [value]="option.value" [disabled]="option.disabled">
        {{ option.value }}
      </option>
    </select>
    <span class="sf-br-dt__sep" aria-hidden="true">:</span>
    <select
      class="form-select"
      aria-label="Minuto"
      [ngModel]="minute"
      (ngModelChange)="onMinuteChange($event)"
      [disabled]="disabled || !datePart"
      [attr.data-testid]="testId ? testId + '-minute' : null"
    >
      <option value="" disabled>mm</option>
      <option *ngFor="let option of minuteOptions; trackBy: trackByValue" [value]="option.value" [disabled]="option.disabled">
        {{ option.value }}
      </option>
    </select>
  </div>
</div>
<div class="sf-br-dt__actions">
  <button type="button" class="sf-br-dt__link" (click)="pickToday()" [disabled]="disabled || todayDisabled"
    [attr.data-testid]="testId ? testId + '-today' : null">Hoje</button>
  <button type="button" class="sf-br-dt__link" (click)="clear()" *ngIf="datePart" [disabled]="disabled"
    [attr.data-testid]="testId ? testId + '-clear' : null">Limpar</button>
  <span class="sf-br-dt__tz" *ngIf="showTime">Horário de Brasília (24 h)</span>
</div>
